module.exports = {
    report(ex) {
        if (window.Sentry) {
            window.Sentry.captureException(ex)
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/x9.js